import React from 'react';
import { observer } from "mobx-react-lite";
import { useTranslation } from 'react-i18next';
import { reputationAmounts } from '../../../../shared/action/ActionModel';
import { FactionSelectionActionDetail } from './components/FactionSelectionActionDetail';
import { Dropdown } from "../../editor/Dropdown";
import { getTreeParent } from '../../../../shared/action/ActionTreeModel';
import { ElementGroup, ElementLabel } from './components/BaseElements';
export const ReceiveReputationActionDetails = observer(({
  action
}) => {
  const {
    t
  } = useTranslation();
  const parentTree = getTreeParent(action);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FactionSelectionActionDetail, {
    name: t("action_editor.property_faction"),
    value: action.fraction,
    valueSetter: action.setFraction.bind(action),
    parentTree: parentTree
  }), /*#__PURE__*/React.createElement(ElementGroup, null, /*#__PURE__*/React.createElement(ElementLabel, null, t("action_editor.property_amount")), /*#__PURE__*/React.createElement(Dropdown, {
    value: action.amount,
    onChange: ({
      target
    }) => action.setAmount(target.value)
  }, reputationAmounts.map(amount => /*#__PURE__*/React.createElement("option", {
    key: amount,
    value: amount
  }, t("content.reputation_amount_" + amount))))));
});